<template>
  <div
    class="border border-gray-200 rounded-2xl shadow-md bg-white/90 backdrop-blur-md"
  >
    <!-- Header -->
    <div
      class="flex justify-center items-center gap-2 rounded-t-2xl border-b border-gray-200 p-3 bg-gradient-to-r from-spicy-mustard-200 to-mocha-mousse-200"
    >
      <Icon
        v-if="structure_dict.file_type !== 'single_file'"
        :icon="headerIcon"
        class="w-6 h-6 text-mocha-mousse"
      />
      <p class="text-xl font-semibold">
        {{ title || structure_dict.name }}
      </p>
    </div>

    <!-- Body -->
    <div
      class="max-h-96 overflow-auto relative flex flex-col p-4 text-sm text-gray-700"
    >
      <div
        v-if="!structure_dict.children || structure_dict.children.length === 0"
        class="italic text-gray-400 text-center"
      >
        Empty archive
      </div>

      <!-- Expand / Collapse All -->
      <div class="absolute top-2 right-2">
        <input
          id="checkbox-option"
          type="checkbox"
          v-model="expandAll"
          hidden
        />

        <label
          v-if="structure_dict.file_type !== 'single_file'"
          for="checkbox-option"
          class="cursor-pointer text-gray-500 hover:text-mocha-mousse transition-colors"
        >
          <Icon
            v-if="!expandAll"
            icon="mdi:arrow-expand-all"
            class="w-5 h-5"
            title="Expand all folders"
          />
          <Icon
            v-else
            icon="mdi:arrow-collapse-all"
            class="w-5 h-5"
            title="Collapse all folders"
          />
        </label>
      </div>

      <div class="flex flex-col">
        <TreeElement
          :element="structure_dict"
          :level="0"
          :expandAll="expandAll"
          :onFileOpen="(f) => $emit('file-open', f)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from "vue";
import TreeElement from "./TreeElement.vue";
import { Icon } from "@iconify/vue";

const props = defineProps({
  structure_dict: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    default: "",
  },
  investigationId: { type: String, default: '' },
  investigationName: { type: String, default: '' },
});

const emit = defineEmits(['file-open']);

const expandAll = ref(true);

const headerIcon = computed(() => {
  const type = props.structure_dict?.file_type || "folder";
  switch (type) {
    case "zip":
      return "mdi:folder-zip";
    case "folder":
      return "mdi:folder-outline";
    case "h5-folder":
      return "mdi:folder-star-outline";
    default:
      return "mdi:file-outline";
  }
});
</script>
